import { api } from '@/services'

export const list = (params) => {
  return api.get('/admin/priceTable/list', { params })
}

export const show = (id) => {
  return api.get(`/admin/priceTable/show/${id}`)
}

export const update = (item) => {
  return api.put('/admin/priceTable/update', item)
}

export const create = (item) => {
  return api.post('/admin/priceTable/create', item)
}

export const remove = (id) => {
  return api.delete(`/admin/priceTable/delete/${id}`)
}
